import React from 'react'

import moment from 'moment'
import { useTranslate } from 'react-admin'

import { DropdownButton } from '../../../components/actions/dropdownButton'
import { formatAmount } from '../../../utils/formatAmount'

const clientDateFormat = process.env.CLIENT_DATE_FORMAT ?? 'DD/MM/YYYY'
const serverDateFormat = process.env.SERVER_DATE_FORMAT ?? 'YYYY-MM-DD'

export const InvoicesSummaryStep = ({
  invoices,
  classes,
  data,
  onEditClick,
  onUploadFilesClick,
  onRemoveClick,
}) => {
  const translate = useTranslate()

  if (invoices?.length === 0) return <></>

  const onOptionClick = (optionIndex, invoiceIndex, invoice) => {
    if (optionIndex === 0 && onEditClick) onEditClick(invoiceIndex, invoice)
    if (optionIndex === 1 && onUploadFilesClick)
      onUploadFilesClick(invoiceIndex, invoice)
    if (optionIndex === 2 && onRemoveClick) onRemoveClick(invoiceIndex, invoice)
  }

  const handleInvoiceItem = (invoice, invoiceIndex) => {
    const selectedCreditLines = data?.filter(
      (item) => item.id === invoice?.creditLineId
    )
    return (
      <div className={classes.invoiceSummary}>
        <div className={classes.invoiceSummaryTitleLine}>
          <div className={classes.invoiceSummaryTitle}>
            {invoice?.invoiceNumber}
          </div>
          <div>
            <DropdownButton
              className={classes.invoiceButton}
              items={[
                'resources.invoices.actions.create.summary.edit',
                'resources.invoices.actions.create.summary.uploadFiles',
                'resources.invoices.actions.create.summary.remove',
              ]}
              onOptionClick={(optionIndex) =>
                onOptionClick(optionIndex, invoiceIndex, invoice)
              }
            />
          </div>
        </div>
        <div className={classes.invoiceSummaryLine}>
          <div className={classes.invoiceSummaryField}>
            <div className={classes.invoiceSummaryFieldName}>
              {translate(
                'resources.invoices.actions.create.summary.fields.buyer'
              )}
              :
            </div>
            <div className={classes.invoiceSummaryFieldValue}>
              {selectedCreditLines?.length > 0
                ? selectedCreditLines[0].importerName
                : undefined}
            </div>
          </div>
          <div className={classes.invoiceSummaryField}>
            <div className={classes.invoiceSummaryFieldName}>
              {translate(
                'resources.invoices.actions.create.summary.fields.issueDate'
              )}
              :
            </div>
            <div className={classes.invoiceSummaryFieldValue}>
              {moment(invoice?.issueDate, serverDateFormat).format(
                clientDateFormat
              )}
            </div>
          </div>
          <div className={classes.invoiceSummaryField}>
            <div className={classes.invoiceSummaryFieldName}>
              {translate(
                'resources.invoices.actions.create.summary.fields.dueDate'
              )}
              :
            </div>
            <div className={classes.invoiceSummaryFieldValue}>
              {moment(invoice?.dueDate, serverDateFormat).format(
                clientDateFormat
              )}
            </div>
          </div>
          <div className={classes.invoiceSummaryField}>
            <div className={classes.invoiceSummaryFieldName}>
              {translate(
                'resources.invoices.actions.create.summary.fields.amount'
              )}
              :
            </div>
            <div className={classes.invoiceSummaryFieldValue}>
              USD {formatAmount(invoice?.amount)}
            </div>
          </div>
          <div className={classes.invoiceSummaryField}>
            <div className={classes.invoiceSummaryFieldName}>
              {translate(
                'resources.invoices.actions.create.summary.fields.purchaseOrder'
              )}
              :
            </div>
            <div className={classes.invoiceSummaryFieldValue}>
              {invoice?.purchaseOrderNumber ?? '-'}
            </div>
          </div>
          <div className={classes.invoiceSummaryField}>
            <div className={classes.invoiceSummaryFieldName}>
              {translate(
                'resources.invoices.actions.create.summary.fields.filesUploaded'
              )}
              :
            </div>
            <div className={classes.invoiceSummaryFieldValue}>
              {invoice?.files?.length ?? '0'}
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={classes.invoiceSummaryList}>
      {invoices.map(handleInvoiceItem)}
      <div className={classes.invoiceSummaryFooter}>&nbsp;</div>
    </div>
  )
}
